import { render, staticRenderFns } from "./exciseAdmin.vue?vue&type=template&id=02bae652&scoped=true&"
import script from "./exciseAdmin.vue?vue&type=script&lang=js&"
export * from "./exciseAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02bae652",
  null
  
)

export default component.exports